export default __webpack_public_path__ + "static/media/dealAdd.f429178c.jpg";